import React, { useState } from "react";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { FIRESTORE_DB } from "../../../Database/Database";
import { Modal, Button, Form, Row, Col, Alert } from "react-bootstrap";

const CrearProducto = ({ show, onClose }) => {

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [producto, setProducto] = useState({
    codigoProducto: "",
    nombreProducto: "",
    precioFinal: "",
    stock: 1
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProducto(prev => ({ ...prev, [name]: value }));
  };

  const guardarProducto = async () => {
    if (!producto.nombreProducto || !producto.precioFinal) {
      return setError("Nombre y precio son obligatorios");
    }

    setLoading(true);
    setError("");

    try {
      await addDoc(collection(FIRESTORE_DB, "productos"), {
        codigoProducto: producto.codigoProducto || "VARIOS",
        nombreProducto: producto.nombreProducto,
        precioFinal: Number(producto.precioFinal),
        precioVenta: Number(producto.precioFinal),
        precioCosto: 0,
        stock: Number(producto.stock),
        categoria: "VARIOS",
        proveedor: "Carga rápida",
        atributo: "Único",
        cantidadVendida: 0,
        fechaIngreso: serverTimestamp(),
        creadoDesdeVenta: true
      });

      alert("Producto creado. Ahora podés buscarlo y agregarlo a la venta.");

      setProducto({
        codigoProducto: "",
        nombreProducto: "",
        precioFinal: "",
        stock: 1
      });

      onClose();
    } catch (err) {
      setError("Error al crear el producto");
    }

    setLoading(false);
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Crear producto rápido</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}

        <Form>
          <Form.Group className="mb-2">
            <Form.Label>Código (opcional)</Form.Label>
            <Form.Control
              name="codigoProducto"
              placeholder="VARIOS / LIBRE"
              value={producto.codigoProducto}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label>Nombre *</Form.Label>
            <Form.Control
              name="nombreProducto"
              placeholder="Producto no registrado"
              value={producto.nombreProducto}
              onChange={handleChange}
            />
          </Form.Group>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Precio *</Form.Label>
                <Form.Control
                  type="number"
                  name="precioFinal"
                  value={producto.precioFinal}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Cantidad</Form.Label>
                <Form.Control
                  type="number"
                  name="stock"
                  value={producto.stock}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>
        </Form>

        <Alert variant="info" className="mt-3 small">
          Este producto se crea para poder completar la venta y queda registrado en el sistema.
        </Alert>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={guardarProducto} disabled={loading}>
          Guardar producto
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CrearProducto;
